__turbopack_context__.v({
  "arrowIcon": "_6g-aAa_arrowIcon",
  "menuContent": "_6g-aAa_menuContent",
  "trigger": "_6g-aAa_trigger",
});
